import EmphasisMediasSection from '../../components/Site/EmphasisMediasSection';
import EmphasisMediasSectionLoading from '../../components/Site/EmphasisMediasSectionLoading';
import { SectionProps } from '../../components/Site/Section';
import LangEnum from '../../lang/LangEnum';
import { PDF_DEFAULT_COVER_PATH } from '../../lib/MediasLib';
import { ShowroomViewMode } from '../../services/modules/brand-showroom/brand-showroom.types';
import { stringPdfMimeType } from '../media/mimeType';
import useMediaListManager from '../media/useMediaListManager';
import { useTranslation } from '../translation/TranslationContext';
import { brandPdfShowcaseRepository } from './brandPdfShowcase.repository';

const processPdfCoverUrl = (files: File[]) =>
  files.map(async (file: File) => {
    const coverUrl = PDF_DEFAULT_COVER_PATH;
    return {
      file,
      coverUrl,
    };
  });

type BrandPdfMidiasSectionProps = {
  sectionProps: Partial<SectionProps>;
  brandId: string;
  viewMode: ShowroomViewMode;
};
const BrandPdfMidiasSection = ({ sectionProps, brandId, viewMode }: BrandPdfMidiasSectionProps) => {
  const { translate } = useTranslation();
  const emphasisPdfMediaListManager = useMediaListManager({
    id: 'filesShowcase',
    api: brandPdfShowcaseRepository(brandId),
    autoSave: true,
  });

  if (emphasisPdfMediaListManager.loading) {
    return <EmphasisMediasSectionLoading />;
  }

  if (
    sectionProps.readOnly &&
    (emphasisPdfMediaListManager.medias.length === 0 || emphasisPdfMediaListManager.tag === 'ERROR')
  ) {
    return null;
  }

  return (
    <>
      <EmphasisMediasSection
        sectionProps={sectionProps}
        title={translate(LangEnum.GLOBAL_MEDIAS)}
        mimeTypes={stringPdfMimeType}
        processFileCover={processPdfCoverUrl}
        medias={emphasisPdfMediaListManager.medias.map((pdf) => ({
          ...pdf,
          downloadUrl: pdf?.url,
        }))}
        mediaListManager={emphasisPdfMediaListManager}
        addButtonLabel={translate(LangEnum.SHOWROOM_ADD_MEDIA)}
        mobileAddButtonLabel={translate(LangEnum.GLOBAL_ADD_MEDIAS)}
        viewMode={viewMode}
      />
    </>
  );
};

export default BrandPdfMidiasSection;
